import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate, ESTADOS_CITA, TIPOS_CITA } from "@/lib/api";

export const CitasAgendaTto = ({ tid }) => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => {
    api.get(`/treatments/${tid}/citas-agenda`).then((r) => setRows(r.data));
  }, [tid]);
  useEffect(() => {
    load();
  }, [load]);
  const verificar = async (a, v) => {
    try {
      await api.post(`/appointments/${a.id}/verificar`, { verificada: v });
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!rows) return null;
  if (!rows.length) return <p className="text-xs text-slate-400" data-testid="tto-agenda-vacio">Aún no hay citas de la agenda apuntadas en este tratamiento.</p>;
  const hechas = rows.filter((a) => a.estado === "atendida").length;
  const pend = rows.filter((a) => a.fecha < new Date().toISOString().slice(0, 10) && !a.verificada && a.estado !== "anulada").length;
  return (
    <div data-testid="tto-agenda">
      <p className="text-xs text-slate-600 mb-2"><b>{hechas}</b> realizadas · <b>{rows.filter((a) => a.verificada).length}</b> verificadas{pend ? <span className="text-amber-700"> · {pend} pasadas sin verificar</span> : ""}</p>
      <p className="text-[11px] text-slate-500 mb-2">Al marcar «Verificada», la cita se suma sola al contador y a «Citas y fechas»; si la desmarcas, se resta.</p>
      <div className="divide-y divide-slate-100 border border-slate-100 rounded-md">
        {rows.map((a) => (
          <div key={a.id} className="flex items-center gap-3 px-3 py-1.5 text-xs" data-testid={`tto-agenda-${a.id}`}>
            <span className="w-20 font-medium text-slate-800">{fmtDate(a.fecha)}</span>
            <span className="w-24 text-slate-500">{a.inicio}–{a.fin}</span>
            <span className="flex-1 truncate text-slate-600">{[TIPOS_CITA[a.tipo]?.label, a.titulo, a.profesional].filter(Boolean).join(" · ")}</span>
            <span className={`rounded px-1.5 py-0.5 ${a.estado === "atendida" ? "bg-emerald-50 text-emerald-700" : a.estado === "no_vino" || a.estado === "anulada" ? "bg-rose-50 text-rose-700" : "bg-slate-100 text-slate-600"}`}>{ESTADOS_CITA[a.estado] || a.estado}</span>
            <label className="flex items-center gap-1 text-slate-700">
              <input type="checkbox" checked={!!a.verificada} onChange={(e) => verificar(a, e.target.checked)} data-testid={`tto-agenda-verificar-${a.id}`} />Verificada
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
